const url = '/email-engagements';
const Provider = 'EmailEngagements';
const dbModel = 'EmailEngagements';

export { url, Provider, dbModel };
